export default __webpack_public_path__ + "static/media/algeria.19ff9209.png";